export default __webpack_public_path__ + "images/84758f44a114f25f64bee7b040aff41e.svg";